import React from "react";
import { useEffect, useState } from "react";

import { fetchGraphQL } from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import { Link, useParams } from "react-router-dom";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";
import { Size } from "../../../logic/enums.ts";

const RaindropAccountFollowing = () => {
  const { accountId } = useParams();

  const [accounts, setAccounts] = useState(null);

  useEffect(() => {
    fetchGraphQL(`
      query {
        account(id: "${accountId}") {
          followingAccountObjects {
            id
            name
            username
            presignedUrl
          }
        }
      }
    `)
      .then((result) => {
        console.log("RD-3324", result, accountId);
        setAccounts(result.data.account.followingAccountObjects);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [accountId]);

  if (accounts === null) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className={"flex flex-col h-full overflow-y-scroll gap-6 pt-4 px-4"}>
      <RaindropButton
        title="Back"
        to={`/raindrop/account/${accountId}`}
        icon={"fa-chevron-left"}
        style={ButtonStyle.Secondary}
        size={Size.Large}
      />

      <h1 className="font-bold text-3xl w-full text-left">Following</h1>
      <RaindropDivider />
      <div className="flex flex-col h-full overflow-y-auto gap-2">
        {accounts.map((account) => (
          <Link
            to={`/raindrop/account/${account.id}`}
            className="flex flex-row items-center gap-2"
          >
            <AccountAvatar
              presignedUrl={account.presignedUrl}
              username={account.username}
            />
            <h1>{account.username}</h1>
            <i className="fa fa-chevron-right text-color-dark-text-secondary ml-auto"></i>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RaindropAccountFollowing;
